import { render } from "./BaseInputSearch.vue?vue&type=template&id=253c4424"
import script from "./BaseInputSearch.vue?vue&type=script&lang=js"
export * from "./BaseInputSearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__